/* eslint-disable no-console */
<template>
    <div class="main_unit">
        <div v-if="isOtherManager || isCompanyManager" class="store_login_unit">{{brandName}}</div>
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div class="store_List_tbl_unit wd976 tbl_ht_none tbl_bg_blue" v-show="!isInitLoading">
            <table>
                <tbody>
                <tr class="text-center">
                    <th class="wd240 border_bottom_none" style="min-width:240px" v-for="(value,key) in columns" :key="key" @click="sortBy(key)">
                        {{value}}
                        <img class="triangle" v-if="sortOrders[key] > 0" src="../assets/img/UnderTriangleWhite.png" width="15px" height="13px" alt="UnderTriangle">
                        <img class="triangle" v-if="sortOrders[key] <= 0" src="../assets/img/UpTriangleWhite.png" width="15px" height="13px" alt="UpTriangle">
                    </th>
                    <th class="wd495" style="min-width:495px" rowspan="2">店舗住所</th>
                    <th class="wd240" style="min-width:240px" rowspan="2">選択</th>
                </tr>
                <tr>
                    <th class="border_top_none"><input class="wd150" type="text" v-model="searchWord" placeholder="キーワード検索"> </th>
                </tr>
                <tr v-for="storeList in filteredDatas" :key="storeList.brandId">
                    <td class="text_white_space" v-for="(value,key) in columns" :key="key">
                        {{storeList[key]}}
                    </td>
                    <td class="text_white_space">{{storeList.address}}</td>
                    <td class="store_buttan_unit staff_kanri_box">
                        <ul class="ul_tbl_buttan">
                            <li>
                               <router-link class="store_buttan_unit" @click.native="setStoreId(storeList.storeId,storeList.storeName,storeList.adminName)" :to="{ name: toName }">OK</router-link>
                            </li>
                        </ul>
                    </td>
                </tr>
                </tbody>

            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StoreSelect',
    components: {
    },
    data: function () {
        var columns = {
            storeName :"店舗名",
        };
        var sortOrders = {};
        Object.keys(columns).forEach(function (key) {
            sortOrders[key] = 1
        });
        return {
            isInitLoading:true,
            brandId: '',
            storeId: '',
            auth:'',
            columns:columns,
            sortKey:'',
            sortOrders:sortOrders,
            searchWord:'',
            storeContent: [],
            isLoading: false,
            csvResponseData: [],
            showContent: false,
        }
    },
    created: function(){
        this.calc();
    },
    methods:{
        async calc(){
            //ブランドIDを取得
            this.brandId = this.$store.getters['manager/manager'].brandId;
            //権限情報を取得
            this.auth = this.$store.getters['manager/manager'].authorityKbn;

            var params = {}

            // 管理画面店舗一覧取得API
            await this.$axios
                .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/store', { params })
                .then(response => (this.storeContent = response['data']['storeList']))
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.isInitLoading = false);
        },
        sortBy:function(key){
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;

        },
        setStoreId(id,name,adminName) {
            var data = this.$store.getters['store/data'];
            this.$store.dispatch('store/doUpdateId',{data: data, storeId: id, storeName:name,adminName:adminName})
        }
    },
    computed:{
        filteredDatas:function(){
            var data = this.storeContent;

            var sortKey = this.sortKey;
            var order = this.sortOrders[sortKey] || 1;

            if(sortKey){
                data = data.slice().sort(function(a,b){
                    a = a[sortKey];
                    b = b[sortKey];
                    return(a === b ? 0 : a > b? 1 : -1) * order;
                });
            }

            var filterWord = this.searchWord && this.searchWord.toLowerCase();
            if(filterWord){
                data = data.filter(function (row){
                    return Object.keys(row).some(function (){
                        return String(row["storeName"]).toLowerCase().indexOf(filterWord) === 0
                    })
                })
            }

            return data;

        },
        brandPath: function () {
            return this.$store.getters['brand/path']
        },
        isCompanyManager: function () {
            return this.auth == 2
        },
        isOtherManager: function () {
            return this.auth == 6
        },
        brandName: function () {
            let brandName = this.$store.getters['brand/name']

            if (brandName == null) {
                brandName = ''
            }

            return brandName
        },
        toName: function (){
            return this.$store.getters['buttons/selectedManageButtonToName']
        }
    }
}
</script>